import { VStack } from '@genial/components';
import React from 'react';

import { ProductCardItemProps, ProductCardItem } from '../../../../components/ProductCardItem';

export interface ExtraInfosProps {
  infos: ProductCardItemProps[];
}

export const ExtraInfos: React.FC<ExtraInfosProps> = ({ infos }) => {
  if (!infos || infos.length === 0) {
    return null;
  }
  return (
    <VStack space={'stack.xxxs'}>
      {infos.map((info, index) => (
        <React.Fragment key={index}>
          <ProductCardItem {...info} />
        </React.Fragment>
      ))}
    </VStack>
  );
};
